import { useEffect, useRef, useState } from 'react'
import { isAnyBlank } from '../../utils/string'
import {
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  TextField
} from '@mui/material'
import TipoExamenSelector from '../../components/form/TipoExamenSelector/TipoExamenSelector'
import AsignaturaSelector from '../../components/form/AsignaturaSelector/AsignaturaSelector'
import css from './ModalNuevoExamen.module.css'

const ModalNuevoExamen = ({ open, onSubmit, onClose, isLoading }) => {
  const [examen, setExamen] = useState({
    nombre: '',
    tipo: '',
    asignaturas: []
  })

  const [selectedFile, setSelectedFile] = useState(null)
  const inputRef = useRef(null)

  useEffect(() => {
    if (open) {
      setExamen({ nombre: '', tipo: '', asignaturas: [] })
      setSelectedFile(null)
    }
  }, [open])

  const isSubmitDisabled =
    isAnyBlank(examen.nombre, examen.tipo) || !selectedFile

  const handleSubmit = () => {
    onSubmit({
      nombre: examen.nombre,
      tipo: examen.tipo,
      asignaturas: examen.asignaturas,
      archivo: selectedFile
    })
  }

  const handleFileChange = e => {
    if (e.target.files.length > 0) {
      setSelectedFile(e.target.files[0])
    }
  }

  const handleUploadClick = () => {
    inputRef.current?.click()
  }

  return (
    <Dialog onClose={onClose} open={open} fullWidth maxWidth='md'>
      <DialogTitle>Nuevo examen</DialogTitle>
      <DialogContent className={css.main}>
        <DialogContentText className={css.intro}>
          Utiliza este formulario para crear un nuevo examen
        </DialogContentText>
        <TextField
          className={css.input}
          label='Nombre'
          value={examen.nombre}
          onChange={e => setExamen({ ...examen, nombre: e.target.value })}
          variant='standard'
        />
        <TipoExamenSelector
          className={css.input}
          label='Tipo de examen'
          value={examen.tipo}
          onChange={e => setExamen({ ...examen, tipo: e.target.value })}
          variant='standard'
        />
        <AsignaturaSelector
          className={css.input}
          label='Asignaturas'
          multiple={true}
          value={examen.asignaturas}
          onChange={(event, newValue) =>
            setExamen({
              ...examen,
              asignaturas: newValue?.map(asig => asig.id) || []
            })
          }
        />
        <div className={css.file}>
          <p>Adjuntar archivo PDF del examen</p>
          <Button size='small' type='secondary' onClick={handleUploadClick}>
            Seleccionar examen
          </Button>
          <input
            ref={inputRef}
            type='file'
            accept='application/pdf'
            name='pdf'
            onChange={handleFileChange}
            hidden
          />
          {selectedFile && (
            <span className={css.filename}>{selectedFile.name}</span>
          )}
        </div>
      </DialogContent>
      <DialogActions>
        <Button color='error' onClick={onClose}>
          Cancelar
        </Button>
        <Button
          disabled={isSubmitDisabled || isLoading}
          color='primary'
          onClick={handleSubmit}
          startIcon={isLoading && <CircularProgress size={12} />}
        >
          Enviar
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default ModalNuevoExamen
